// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"vendors-node_modules_pnpm_cornerstonejs_dicom-image-loader_4_20_0__cornerstonejs_core_4_20_0_-738135":1 }[chunkId]) return "static/css/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}